import type { Tenant } from '@mg/shared';
import { DeleteWorkspaceCard } from '../../../components/workspace/DeleteWorkspaceCard';

/**
 * The Danger zone page (spec:168, :196; web.md §6.5): the existing Danger Zone card and nothing else,
 * no heading card and no footer (there is nothing to save). Admins only: a member is sent to Brand
 * information instead (E30), and the card hides itself for anyone who may not delete.
 */
export function DangerZonePage({ workspace, canEdit }: { workspace: Tenant; canEdit: boolean }) {
  return <DeleteWorkspaceCard workspace={workspace} canEdit={canEdit} />;
}
